import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../services/api'
import { useToast } from './useToast'

interface UseUserSetupOptions {
  redirectOnIncomplete?: boolean
}

export function useUserSetup(options: UseUserSetupOptions = {}) {
  const [isLoading, setIsLoading] = useState(true)
  const [isComplete, setIsComplete] = useState(false)
  const navigate = useNavigate()
  const { toast } = useToast()

  useEffect(() => {
    const checkSetup = async () => {
      try {
        await api.get('/api/v1/feed')
        setIsComplete(true)
      } catch (error: any) {
        const code = error.response?.data?.code
        
        if (code === 'USER_SETUP_REQUIRED' || code === 'USERNAME_REQUIRED') {
          setIsComplete(false)
          if (options.redirectOnIncomplete) {
            toast({
              title: 'Profile Setup Required',
              description: 'Please complete your profile setup to continue.',
              variant: 'default'
            })
            navigate('/profile/setup')
          }
        } else {
          // Other errors don't affect setup state
          setIsComplete(true)
        }
      } finally {
        setIsLoading(false)
      }
    }

    checkSetup()
  }, [options.redirectOnIncomplete, navigate])

  return { isLoading, isComplete }
} 